import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Form, Input, Select, Row, Col
} from 'antd';

import * as alertsNames from '@pages/Alertas/helpers/defaultAlerts/alertsNames';
import LayoutStep from '../../components/LayoutStep';
import SpecialCard from '../../components/SpecialCard';

import styles from './GeneralAlarma.module.less';

import useGeneralAlarma from './useGeneralAlarma';

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

function GeneralAlarma(props) {

  const { onNext,form } = props;
  const { t } = useTranslation();
  const isEditDefault = useSelector(({ alarms }) => alarms.isEditDefault); 
  const alarmaItem = useSelector(({ alarms }) => alarms.createEditValues); 

  const { 
    displayState,
    onChangeOrigin,
    dataDevicesTypes,
    dataGateway,
    businessData,
    onDataChange,
    alarm_id
  } = useGeneralAlarma();

  useEffect(()=>{
    if(alarmaItem?.device_type == null){
      form.setFieldsValue({
          device_type: undefined
      })
    }
  },[alarmaItem]);

  console.log('isEditDefault',isEditDefault)
  return (
    <LayoutStep onNext={onNext}>
      <SpecialCard>
        <Row gutter={[16, 8]}>
          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }}
          >
            <Item
              className={styles.short_input}
              label={t('views.dynamic_alarms_create_edit.labels.name')}
              name="name"
              rules={[
                {
                  required: true,
                  message: t('views.dynamic_alarms_create_edit.feedbacks.required_input'),
                },
                () => ({
                  validator(_, val) {

                    const alertsDefaults = Object.values(alertsNames);
                    if (!isEditDefault && alertsDefaults.includes(val)) {

                      return Promise.reject(
                        t('views.dynamic_alarms_create_edit.feedbacks.reserved_name'),
                      );

                    }
                    return Promise.resolve();

                  },
                }),
              ]}
            >
              <Input style={{ width: '100%' }} disabled={isEditDefault} />
            </Item>
          </Col>

          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }}> 
            <Item
              className={styles.short_input}
              label={t('forms.users.labels.business_line')}
              name="business_type_id" //business_type
              rules={[
                {
                  required: true,
                  message: t('forms.users.placeholders.business_line'),
                },
              ]}
            >
              <Select
                onChange={(value) => onDataChange(value)} 
                style={{ width: '100%' }}
                disabled={alarm_id}
                placeholder={t('forms.users.placeholders.business_line')} 
                options={businessData}

              /> 
            </Item>  
          </Col>
          
          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }}
          >
            <Item
              className={styles.short_input}
              label={t('views.dynamic_alarms_create_edit.labels.severity')}
              name="severity"
            >
              <Select disabled={isEditDefault}>
                <Option value="Critical">
                  {t('views.dynamic_alarms_create_edit.severity_options.critical')}
                </Option>
                <Option value="Warning">
                  {t('views.dynamic_alarms_create_edit.severity_options.warning')}
                </Option>
                <Option value="Info">
                  {t('views.dynamic_alarms_create_edit.severity_options.info')}
                </Option>
              </Select>
            </Item>
          </Col>

          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }}
          >
            <Item
              className={styles.short_input}
              label={t('views.dynamic_alarms_create_edit.labels.type_rule')}
              name="origin"
              rules={[{ required: true }]}
            >
              <Select
                disabled={isEditDefault}
                onChange={(e) => onChangeOrigin(e)}
              >
                <Option value="Inst-Telemetry-Other">
                  {t('views.dynamic_alarms_create_edit.rule_type_options.telemetry')}
                </Option>
                <Option value="Missing">
                  {t('views.dynamic_alarms_create_edit.rule_type_options.missing')}
                </Option>
                <Option value="Device-Disconnection">
                  {t('views.dynamic_alarms_create_edit.rule_type_options.Device_disconnection')}
                </Option>
              </Select>
            </Item>
          </Col>
          
          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }} >
            <Item
              className={styles.short_input}
              label={'Gateway Mac'}
              name="gateway"
              rules={[{ required: true }]}
            >
              <Select
                disabled={isEditDefault} 
                showSearch
                optionFilterProp="children"  
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={dataGateway}
              > 
              </Select>
            </Item>
          </Col>

          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }} style={{display:displayState}}
          >
            <Item
              className={styles.short_input}
              label={t('views.dynamic_alarms_create_edit.labels.devices_type')}
              name="device_type"
            >
              <Select
                disabled={isEditDefault}
                values={alarmaItem?.device_type || undefined}
                showSearch
                optionFilterProp="children"  
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={dataDevicesTypes}
              > 
              </Select>
            </Item>
          </Col>

          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }}
          >
            <Item
              className={styles.large_input}
              label={t('views.dynamic_alarms_create_edit.labels.description')}
              name="description"
              rules={[
                {
                  required: true,
                  message: t('views.dynamic_alarms_create_edit.feedbacks.require_description'),
                },
              ]}
            >
              <TextArea className={styles.text_area} rows={3} disabled={isEditDefault} />
            </Item>
          </Col> 

        </Row>
      </SpecialCard>
    </LayoutStep>
  );

}

GeneralAlarma.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default GeneralAlarma;
